import React from "react";

const WindowLevel = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.4 15.9778C3.26196 15.671 0 12.2164 0 8C0 3.78356 3.26196 0.328982 7.4 0.0221615V0H8C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16H7.4V15.9778ZM1.2 8C1.2 11.5534 3.92549 14.4701 7.4 14.7739L7.4 1.22611C3.92549 1.52986 1.2 4.44664 1.2 8Z"
        fill={color}
      />
    </svg>
  );
};

export default WindowLevel;
